import { IControllerConstructor } from 'angular';
import { CreateOperatorController } from './create/operator-create.controller';
import { EditOperatorController } from './edit/operator-edit.controller';
import { OperatorsListController } from './list/operators-list.controller';
import { OperatorServicesListController } from './services/operator-services-list.controller';
import { OperatorSummaryController } from './summary/operator-summary.controller';
import { OperatorPageController } from './operator-page.controller';

import * as OperatorRoutes from './operators.routes';
import { TransportOperatorServicesCreateController } from './services/create/transport-operator-services-create.controller';
import { TransportOperatorServiceEditController } from './services/edit/transport-operator-service-edit.controller';

export const initialise = () => {
  angular.module('app.operators', [
    'app.layout',
    'ngSanitize'
  ]).controller('OperatorsCreateController', <IControllerConstructor>CreateOperatorController)
    .controller('OperatorEditController', <IControllerConstructor>EditOperatorController)
    .controller('OperatorsListController', <IControllerConstructor>OperatorsListController)
    .controller('OperatorSummaryController', <IControllerConstructor>OperatorSummaryController)
    .controller('OperatorPageController', <IControllerConstructor>OperatorPageController)
    .controller('OperatorServicesListController', <IControllerConstructor>OperatorServicesListController)
    .controller('TransportOperatorServicesCreateController', <IControllerConstructor>TransportOperatorServicesCreateController)
    .controller('TransportOperatorServiceEditController', <IControllerConstructor>TransportOperatorServiceEditController)
    .constant('statusConstants', {
      AUTHORISED: 'AUTHORISED',
      AWAITING_AUTHORISATION: 'AWAITING_AUTHORISATION',
      DECLINED: 'DECLINED',
      DRAFT: 'DRAFT',
      NONE: 'NONE',
      DELETED: 'DELETED',
      ACTIVE: 'ACTIVE',
      PENDING: 'PENDING',
      ENABLED: 'ENABLED'
    });

  OperatorRoutes.initialise();
};
